import React from "react"
import RichContentTextBlock from "./richContentTextBlock"
import Img from "gatsby-image"
import { GatsbyImage, getImage } from "gatsby-image"
import {
  Box,
  Flex,
  Grid,
  Heading,
  Link,
  Text,
  AspectRatio,
} from "@theme-ui/components"
import customBorder from "../images/custom-border.svg"
import loadable from "@loadable/component"

// Begin swiper
import SwiperCore, { Pagination, Mousewheel, A11y, Autoplay } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"

SwiperCore.use([Mousewheel, Pagination, A11y, Autoplay])
// End swiper

const Other = loadable(() => import("../components/other"), { ssr: false })

const HeroBlock = ({ text, title, gallery, documents, alternate }) => {
  // console.log(gallery)
  return (
    <Box
      mb={4}
      sx={{
        paddingTop: 4,
        backgroundImage: `url(${customBorder})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      {title && (
        <Heading sx={{ color: "primary", fontSize: 5, mb: 4 }}>{title}</Heading>
      )}
      {!alternate ? (
        <Grid
          columns={[1, 1, gallery.length > 0 ? 2 : 1]}
          sx={{
            img: {
              objectFit: "contain!important",
            },
          }}
        >
          <Box>
            <RichContentTextBlock html={text} />
          </Box>
          <Box
            sx={{
              ".gatsby-image.wrapper": {
                height: "200px!important",
              },
            }}
          >
            {gallery.length > 0 && (
              <>
                {gallery.length > 1 ? (
                  <Swiper
                    spaceBetween={40}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 2000 }}
                    loop={gallery.lenght > 1 ? true : false}
                  >
                    {gallery.map(image => (
                      <SwiperSlide
                        key={image.originalId}
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <AspectRatio ratio={1}>
                          <Img
                            fluid={image.fluid}
                            style={{
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </AspectRatio>
                        {image.title && (
                          <Text
                            as="p"
                            mt={2}
                            mb={0}
                            sx={{
                              fontSize: "16px",
                              textAlign: "center",
                              color: "primary",
                              mt: 4,
                            }}
                          >
                            {image.title}
                          </Text>
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <Box>{gallery[0] && <Img fluid={gallery[0].fluid} />}</Box>
                )}
              </>
            )}
          </Box>
        </Grid>
      ) : (
        <Grid columns={[1]}>
          <Box>
            <RichContentTextBlock html={text} />
          </Box>
          <Box>
            {gallery.length > 0 && (
              <Swiper
                spaceBetween={32}
                slidesPerView={2}
                pagination={{ clickable: true }}
                autoplay={{ delay: 2000 }}
                loop={gallery.lenght > 2 ? true : false}
                breakpoints={{
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  // when window width is >= 480px
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                }}
              >
                {gallery.map(image => (
                  <SwiperSlide
                    key={image.originalId}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <AspectRatio ratio={1}>
                      <Img
                        fluid={image.fluid}
                        style={{
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </AspectRatio>
                    {image.title && (
                      <Text as="p" mt={2} mb={0} sx={{ fontSize: 1 }}>
                        {image.title}
                      </Text>
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </Box>
        </Grid>
      )}
      {documents && documents.length > 0 && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: [
              "1fr 1fr",
              "1fr 1fr 1fr 1fr ",
              "repeat(4, 1fr)",
            ],
            gap: 4,
          }}
        >
          {documents.map(document => (
            <Box
              sx={{
                border: "1px solid",
                borderColor: "#eeeeee",
                maxWidth: "242px",
                marginBottom: 3,
              }}
            >
              <Other document={document} />
              <Box>
                <Link
                  href={document.url}
                  target="blank"
                  rel="nofollow noopener"
                >
                  {document.title}
                </Link>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default HeroBlock
